module.exports = __webpack_public_path__ + "static/media/icon-email-black.54909151.svg";